export const user = state => state.user
export const checkPermissions = state => permissions => {
  return permissions.some(permission => state.permissions.includes(permission))
}
